import {Component, OnInit, OnDestroy} from '@angular/core';
import {UserService, ScrollService, ScrollParams,MessagesServices} from '../../api';
import * as _ from 'lodash';
import {ActivatedRoute} from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { ConfirmDialogComponent } from '../../';
import 'intl';
import 'intl/locale-data/jsonp/en';
@Component({
    selector: 'app-my-package',
    templateUrl: './my-package.component.html',
    styleUrls: ['./my-package.component.css']
})
export class MyPackageComponent implements OnInit, OnDestroy {
    private activePackages = [];
    private packageHistory = [];
    private loading: boolean = true;
    private currentTab: number = 0;
    private scrollParams: ScrollParams = new ScrollParams();
    private scrollSubscriber = null;
    private title: string = '';
    private billing_status: number = 0;
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';
    msg3: any = '';
    title3: any = '';
    dialogRef: MdDialogRef<ConfirmDialogComponent>;
    public onlineOffline: boolean = navigator.onLine;

    constructor(public toastyService: ToastyService,private userService: UserService, private sm: MessagesServices, private scrollService: ScrollService, private route: ActivatedRoute,public dialog: MdDialog) {
        window.addEventListener('online', () => {this.onlineOffline = true;});
        window.addEventListener('offline', () => {this.onlineOffline = false;});
        this.messages = this.sm.messags;
        this.setMessages();
    }

    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_SUBSCRIPTION_CANCELLED_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_SUBSCRIPTION_CANNOT_BE_CANCELLED') {
                    this.title2 = this.messages[i].title;
                    this.msg2 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_SUBSCRIPTION') {
                    this.msg3 = this.messages[i].message;
                }
            }
        }
    }

    cancelSubscription(index) {
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
            disableClose: false,
        });
        this.dialogRef.componentInstance.message = this.msg3;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result && result === true) {
                this.loading = true;
                this.userService.cancelSubscription(this.activePackages[index].id).subscribe((res) => {
                    this.loading = false;
                    if (res && res.status === 'success') {
                        this.handleResponse(res.status);
                        this.onTabChanged(0);
                    } else {
                        this.handleResponse(res.status);
                    }
                }, (err) => {
                    this.handleResponse('error');
                });
            }
        });
    }

    handleResponse(response) {
        if (response === 'success') {
            let toastOptions: ToastOptions = {
                title: this.title1,
                msg: this.msg1,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.success(toastOptions);
        } else {
            let toastOptions: ToastOptions = {
                title: this.title2,
                msg: this.msg2,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.error(toastOptions);
        }
    }

    ngOnInit() {
        if (this.route.snapshot.data['title']) {
            this.title = this.route.snapshot.data['title'];
        }
        this.onTabChanged(this.currentTab);
        this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getData(this.currentTab));
    }

    onTabChanged(index: number) {
        this.currentTab = index;
        this.activePackages = [];
        this.packageHistory = [];
        this.scrollParams = new ScrollParams();
        this.getData(index);
    }

    getData(index) {
        if (index === 0) {
            this.getMyActivePackages();
        } else if (index === 1) {
            this.getMyPackagesHistory();
        }
    }

    public getMyActivePackages() {
        if (this.scrollParams.recordsFinished) {
            return;
        }
        this.loading = true;
        if(this.onlineOffline) {
            this.userService.getMyActivePackages(this.scrollParams).subscribe((data) => {
                if (data.length > 0) {
                    data.forEach((arrayItem) => {
                        arrayItem.usage = (((arrayItem.songs - arrayItem.songsLeft) + (arrayItem.sounds - arrayItem.soundsLeft)) / (arrayItem.songs + arrayItem.sounds)) * 100;
                        this.billing_status = parseInt(arrayItem.user.billing_status);
                        this.activePackages.push(arrayItem);
                    });
                    this.scrollParams.page++;
                } else {
                    this.scrollParams.recordsFinished = true;
                }
                this.activePackages = _.uniqBy(this.activePackages, 'id');
                this.loading = false;
            });
        } else{
            this.loading = false;
        }
    }

    public getMyPackagesHistory() {
        if (this.scrollParams.recordsFinished) {
            return;
        }
        this.loading = true;
        if(this.onlineOffline){
        this.userService.getMyPackagesHistory(this.scrollParams).subscribe((res) => {
            if (res.length > 0) {
                res.forEach((arrayItem) => {
                    this.packageHistory.push(arrayItem);
                });
                this.scrollParams.page++;
            } else {
                this.scrollParams.recordsFinished = true;
            }
            this.packageHistory = _.uniqBy(this.packageHistory, 'id');
            this.loading = false;
        });
        } else{
            this.loading = false;
        }
    }

    ngOnDestroy() {
        if (this.scrollSubscriber != null) {
            this.scrollSubscriber.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/user/my-package/my-package.component.ts